import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import "swiper/css";
import 'swiper/css/pagination';
import CSS from "./static/css/BrandInfoSwipeBox.module.css";
import { BrandInfoProps, BrandInfoVersion_Type } from "../BrandInfo/interface/BrandInfo.interface";
import brand_info_img_1 from "./static/img/brand_info_img_1.png";
import brand_info_img_2 from "./static/img/brand_info_img_2.png";
import brand_info_img_3 from "./static/img/brand_info_img_3.png";
import brand_info_img_4 from "./static/img/brand_info_img_4.png";
import BrandInfo from "../BrandInfo/BrandInfo";

const BRAND_INFO_LIST: BrandInfoProps[] = [
    {
        description: "스튜디오 촬영 필수앱",
        title_line1: "촬영부터 편집,",
        title_line2: "제작까지",
        title_line3: "OOPS",
        image: brand_info_img_1,
    },{
        description: "촬영 테마 미리 보고 결정",
        title_line1: "다가오는 촬영 일정",
        title_line2: "",
        title_line3: "푸시 알림",
        image: brand_info_img_2,
    },{
        description: "PC에서도 앱에서도 자유롭게 확인",
        title_line1: "언제나",
        title_line2: "",
        title_line3: "촬영 사진 확인",
        image: brand_info_img_3,
    },{
        description: "묶고, 압축하고, 보내는 불편함 제로",
        title_line1: "손쉽게 사진 선택",
        title_line2: "",
        title_line3: "제품 신청",
        image: brand_info_img_4,
    }
]

const BrandInfoSwipeBox = (
    {
        version = "v1"
    }:{
        version?: BrandInfoVersion_Type;
    }
) => {
    return (
        <div className={CSS.l_BrandInfoSwipeBox_main}>
            <Swiper
                spaceBetween={50}
                modules={[Pagination]}
                pagination={{
                    clickable: true,
                }}
                loop={true}
            >
                {
                    BRAND_INFO_LIST.map((brand_info, index) => (
                        <SwiperSlide key={index}>
                            <BrandInfo {...brand_info} version={version}/>
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    )
}

export default BrandInfoSwipeBox;